module.exports = {
  'lan': 'zhTitle'
}